/**
 * Created by mykurisu on 2017/8/2.
 */
import React from 'react'
import {connect} from 'react-redux'
import {
    Tab,
    TabBody,
    NavBar,
    NavBarItem,
} from 'react-weui'
import ListenerManageListRejected from './ListenerManageListRejected'
import ListenerManageListPassed from './ListenerManageListPassed'

class ListenerManageTab extends React.Component {

    constructor() {
        super();
        this.handleBarSelectFirst = this.handleBarSelectFirst.bind(this);
        this.handleBarSelectSec = this.handleBarSelectSec.bind(this);
    }

    handleBarSelectFirst() {
        this.props.dispatch({
            type: 'LISTENER_MANAGE_BAR_FIRST'
        });
    }

    handleBarSelectSec() {
        this.props.dispatch({
            type: 'LISTENER_MANAGE_BAR_SEC'
        });
    }

    render (){
        const {listenermanage} = this.props;
        return (
            <div>
                <Tab>
                    <NavBar>
                        <NavBarItem className="record-page-navbar-item" active={listenermanage.tab === 0} onClick={this.handleBarSelectFirst}>授权听众({listenermanage.listener_passed.sum_count})</NavBarItem>
                        <NavBarItem className="record-page-navbar-item" active={listenermanage.tab === 1} onClick={this.handleBarSelectSec}>未授权听众({listenermanage.listener_rejected.sum_count})</NavBarItem>
                    </NavBar>

                    <TabBody>
                        <div style={{display: listenermanage.tab === 0 ? null : 'none'}}>
                            <ListenerManageListPassed />
                        </div>
                        <div style={{display: listenermanage.tab === 1 ? null : 'none'}}>
                            <ListenerManageListRejected />
                        </div>
                    </TabBody>
                </Tab>
            </div>
        )
    }
}

export default connect(state => ({
    listenermanage: state.listenermanage
}))(ListenerManageTab)


// WEBPACK FOOTER //
// ./src/components/listenerManage/ListenerManageTab.js